/**
 * In-memory fixtures for the mock services.
 *
 * This is throwaway prototype data. None of it is real, and none of it stands in
 * for the encrypted-at-rest storage model — these are the already-decrypted
 * shapes the owner would see. Kept in one place so the mock services share a
 * single source of state within a session.
 */

import { POLICY_VERSION } from "../../config/policies.js";

/** @returns {import("../../types/models.js").Account} */
function makeDemoAccount() {
  return {
    id: "acct_demo",
    email: "demo@example.com",
    emailVerified: true,
    subscriptionStatus: "active",
    accountStatus: "active",
    deletionRequestedAt: null,
    // Up to date with the current policies, so the mock never trips the gate.
    termsVersion: POLICY_VERSION.terms,
    privacyVersion: POLICY_VERSION.privacy,
  };
}

/** @returns {import("../../types/models.js").RecoveryProfile[]} */
function makeDemoProfiles() {
  return [
    {
      id: "prof_demo",
      label: "Mum's people",
      enabled: true,
      contacts: [
        {
          id: "con_1",
          name: "Rhian Davies",
          telephone: "07700 900123",
          relationship: "Daughter",
        },
        {
          id: "con_2",
          name: "Gareth Davies",
          telephone: "07700 900456",
          relationship: "Son",
        },
      ],
    },
  ];
}

export { makeDemoAccount, makeDemoProfiles };
